import React from 'react';

/* Assets */
import no_image from '@assets/img/no_img.svg';
/* Utils. */
import classnames from 'classnames';

/* Styles */
import css from './nibCardImage.module.sass';

const NibCardImage = ({ title, useUpload = true, imgDesc, onClick = () => {}, src, ...props }) => {
  return (
    <div className={classnames(css.wrap, 'ui-card-image-wrap')}>
      <h4>{title}</h4>
      <div className={classnames(css.box, 'ui-card-image-box')}>
        <p>{imgDesc}</p>
        {useUpload && (
          <div onClick={onClick} className={css.over}>
            <p>Click to upload</p>
          </div>
        )}
        <img src={src ? src : no_image} alt="" />
      </div>
    </div>
  );
};

export default NibCardImage;
